import get from 'lodash.get';
import getBlockByElement from './get-block-by-element';
import updateChildrenPresence from '../../hdrm/utils/helpers/update-children-presence';

const getOptionalChildrenData = (blockNode) => {
  const block = getBlockByElement(blockNode);
  if (!block) return [];

  const { ownerDocument } = blockNode;
  const clonedNode = ownerDocument.importNode(blockNode, true);

  const optionalChildren = get(block, 'availableSettings.optionalChildren', []);

  return optionalChildren.reduce((childrenNodes, { id, querySelector }) => {
    const childrenNode = clonedNode.querySelector(querySelector);
    if (childrenNode) {
      childrenNodes.push({
        id,
        el: childrenNode,
        isEnabled: true,
        querySelector,
      });
      return childrenNodes;
    }

    updateChildrenPresence(clonedNode, querySelector, true);
    const hiddenChildrenNode = clonedNode.querySelector(querySelector);
    if (hiddenChildrenNode) {
      childrenNodes.push({
        id,
        el: hiddenChildrenNode,
        isEnabled: false,
        querySelector,
      });
      return childrenNodes;
    }

    return childrenNodes;
  }, []);
};

export default getOptionalChildrenData;
